<template>
  <div class="container">
    <div class="submission-form">
      <div class="submission-form-header">
        <h3>{{ templateDoc.title }}</h3>
      </div>
      <div class="submission-form-body">
        <div v-if="templateLoaded">
          <div v-for="template in templateDoc['templates']">
            <div v-if="template.mappings && template.mappings.children">
              <form-data-tree :templateId="template.id" :mappings="template.mappings.children" :dataBus="dataBus"
                              :showErrors="showErrors" :formErrors="formErrors"></form-data-tree>
            </div>
          </div>
          <h5 class="error-msg" v-if="showErrors">Please fill all the required fields.</h5>
        </div>
        <div v-else>
          <content-placeholders>
            <content-placeholders-img :style="{height: '400px'}" />
          </content-placeholders>
        </div>
      </div>
      <div class="submission-form-footer">
        <b-button class="submit-button" variant="secondary" @click="submitForm">Submit</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import FormDataTree from '../../components/submit/formDataTree'

export default {
  data () {
    return {
      templateLoaded: false,
      templateDoc: {},
      dataBus: new Vue(),
      formData: {},
      singleSelectGroups: {},
      formErrors: {},
      showErrors: false
    }
  },
  created () {
    this.dataBus.$on('updateFormField', (templateId, id, value, parentId, parentType) => {
      this.updateFormField(templateId, id, value, parentId, parentType)
    })
  },
  mounted () {
    Vue.axios.get('/submissions/' + this.$route.params.tempDocId)
      .then(res => {
        if (res.data.success) {
          let templateDoc = res.data.templateDoc
          let formData = {}
          let singleSelectGroups = {}
          templateDoc.templates.forEach((template) => {
            console.log('template = ', template)
            if (template.mappings) {
              this.initializeSingleSelectGroups(singleSelectGroups, template.mappings.children)
              formData[template.id] = this.initializeFormData({}, template.mappings.children)
            }
          })
          this.templateDoc = templateDoc
          this.formData = formData
          this.singleSelectGroups = singleSelectGroups
          this.templateLoaded = true
        } else {
          Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  components: {
    'form-data-tree': FormDataTree
  },
  methods: {
    initializeFormData (formData, mappings) {
      mappings.forEach((child) => {
        if (child.map_type === 'shape') {
          formData[child.id] = child.data_type === 'checkbox' ? false : ''
        } else if (child.data_type !== 'table_column' ||
              child.data_type !== 'table_row' ||
              child.data_type !== 'table_entry' ||
              child.data_type !== 'table_header') {
          this.initializeFormData(formData, child.children)
        }
      })
      return formData
    },
    initializeSingleSelectGroups (singleSelectGroups, mappings) {
      mappings.forEach((child) => {
        if (child.map_type === 'group') {
          if (child.data_type === 'single_select') {
            singleSelectGroups[child.id] = child.children.map((option) => {
              return option.id
            })
          } else {
            this.initializeSingleSelectGroups(singleSelectGroups, child.children)
          }
        }
      })
      return singleSelectGroups
    },
    updateFormField (templateId, id, value, parentId, parentType) {
      if (parentType === 'single_select') {
        this.singleSelectGroups[parentId].forEach((optionId) => {
          if ((optionId !== id) && this.formData[templateId][optionId]) {
            this.formData[templateId][optionId] = false
          }
        })
      }
      this.formData[templateId][id] = value
    },
    validateFormEntry (formErrors, templateId, mappings) {
      mappings.forEach((child) => {
        if (child.map_type === 'shape') {
          if (child.required && !this.formData[templateId][child.id]) {
            formErrors[child.id] = true
          }
        } else {
          if ((child.data_type === 'single_select' || child.data_type === 'multi_select') && child.required) {
            formErrors[child.id] = true
            child.children.forEach((option) => {
              if (this.formData[templateId][option.id]) {
                formErrors[child.id] = false
              }
            })
          } else if (child.data_type !== 'table_column' ||
              child.data_type !== 'table_row' ||
              child.data_type !== 'table_entry' ||
              child.data_type !== 'table_header') {
            this.validateFormEntry(formErrors, templateId, child.children)
          }
        }
      })
      return formErrors
    },
    validateFormData () {
      this.formErrors = {}
      var formErrors = {}
      this.templateDoc.templates.forEach((template) => {
        if (template.mappings) {
          this.validateFormEntry(formErrors, template.id, template.mappings.children)
        }
      })
      let errors = Object.values(formErrors).filter(Boolean).length
      this.formErrors = errors > 0 ? formErrors : {}
      this.showErrors = errors > 0
      return errors === 0
    },
    submitForm () {
      let isValid = this.validateFormData()
      if (isValid) {
        this.templateLoaded = false
        Vue.axios.post('/submissions/submit', { templateDocId: this.templateDoc.id, formData: JSON.stringify(this.formData) })
          .then(res => {
            Vue.toasted.show(res.data.msg)
            let templateDoc = Object.assign({}, this.templateDoc)
            this.templateDoc = {}
            this.formData = {}
            this.formErrors = {}
            this.showErrors = false
            this.resetData(templateDoc)
          })
          .catch(error => {
            console.log('error', error)
          })
      }
    },
    resetData (templateDoc) {
      setTimeout(() => {
        let formData = {}
        templateDoc.templates.forEach((template) => {
          formData[template.id] = this.initializeFormData({}, template.mappings.children)
        })
        this.templateDoc = templateDoc
        this.formData = formData
        this.templateLoaded = true
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>

.container {
  padding: 3%;
  align-items: center;
}

.submission-form {
  border: 10px solid white;
}

.submission-form-header {
  padding: 10px;
  background-color: #0e2547;
  color: white;
  text-align: center;
}

.submission-form-body {
  padding: 10px;
  border-top: 10px solid white;
  background-color: #eaeaea;
}

.submission-form-footer {
  padding: 10px;
  text-align: center;
  border-top: 10px solid white;
  background-color: #0e2547;
}

.submit-button {
  border-radius: 20px;
}

.error-msg {
  color: red;
  font-style: italic;
}

</style>


// WEBPACK FOOTER //
// src/views/submit/submitForm.vue